'use client'

import { SimpleSection } from '@/Components/custom/simple-section'
import NewsCard from '@/Components/custom/news-card'
import { Translatable } from '@/types'
import useLocalizedValue from '@/hooks/use-localized-value'

export interface NewsSectionProps {
  title?: Translatable<string>
  subtitle?: Translatable<string>
  articles?: {
    id: number
    title: Translatable<string>
    excerpt: Translatable<string>
    content: Translatable<string>
    media: Translatable<string>
    published_at: string
  }[]
}

export default function NewsSection({ title, subtitle, articles = [] }: NewsSectionProps) {
  return (
    <SimpleSection
      top={false}
      title={useLocalizedValue(title || {})}
      subtitle={useLocalizedValue(subtitle || {})}
    >
      <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-4 lg:gap-4">
        {articles.map((article) => (
          <div key={article.id}>
            <NewsCard
              id={article.id}
              title={useLocalizedValue(article.title) || ''}
              excerpt={useLocalizedValue(article.excerpt) || ''}
              media={useLocalizedValue(article.media) || ''}
              publishedAt={article.published_at}
            />
          </div>
        ))}
      </div>
    </SimpleSection>
  )
}
